import type { StartEndLines } from '@o2d/grid-layout';

/**
 * Deep-compare two sectionsStartEndLines maps for value equality.
 * Returns true if both maps contain the same keys with identical
 * startLine and endLine values. Handles undefined parameters.
 */
export function areSectionsStartEndLinesEqual(
    a: Map<string, StartEndLines> | undefined,
    b: Map<string, StartEndLines> | undefined,
): boolean {
    if (a === b) return true;
    if (!a || !b) return false;
    if (a.size !== b.size) return false;

    for (const [key, valueA] of a) {
        const valueB = b.get(key);
        if (!valueB) return false;
        if (valueA.startLine !== valueB.startLine || valueA.endLine !== valueB.endLine) return false;
    }

    return true;
}
